var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chrome") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SideNav-Revised",
    transform: "translate(-28.000000, -839.000000)",
    fill: "#F16334",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.000000, 837.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.600000, 2.400000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0.9 11.5710923 0.8988 15.9024 15.156 15.9024 15.1566 11.5710923 16.9566 11.5710923 16.9566 17.7035538 -0.9 17.7035538 -0.9 11.5710923"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    points: "8.92858 -1.0658141e-15 8.92858 11.8841538 7.12858 11.8841538 7.12858 -1.0658141e-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-7",
    points: "12.0154296 6.67391305 13.2811704 7.95371772 8.0283 13.1488643 2.77542956 7.95371772 4.04117044 6.67391305 8.028 10.6164"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9369f92623e6c838a2b796497fbdf8a2.svg";
export { ForwardRef as ReactComponent };